import script from "./ClosedPause.vue?vue&type=script&setup=true&lang=js"
export * from "./ClosedPause.vue?vue&type=script&setup=true&lang=js"

import "./ClosedPause.vue?vue&type=style&index=0&id=874b03f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-874b03f4"]])

export default __exports__